import { FaArrowRight } from "react-icons/fa";
import { Link } from 'react-router-dom'; // Import Link from React Router

const Footer = () => {
  return (
    <div className="md:px-24 px-4">
      <footer className="bg-[#03897B] text-white md:px-20 px-5 md:pt-10 pt-4">
        <div className="flex justify-between">
          {/* Links Section with Responsive Margin */}
          <div className="w-full text-left">
            <h3 className="font-semibold text-[10px] md:text-[32px] ">LINKS</h3>
            <ul className="md:-space-y-1 -space-y-2">
              <li><Link to="/TermsAndCondition" className="text-[10px] md:text-[32px] hover:underline font-light">Terms and conditions</Link></li>
              <li><Link to="/PrivacyPolicy" className="text-[10px] md:text-[32px] hover:underline font-light">Privacy policy</Link></li>
              <li><Link to="/DataPolicy" className="text-[10px] md:text-[32px] hover:underline font-light">Data Policy</Link></li>
              <li><Link to="/FrequentlyAskedQuestions" className="text-[10px] md:text-[32px] hover:underline font-light">Frequently asked questions</Link></li>
              <li><Link to="/Contact" className="text-[10px] md:text-[32px] hover:underline font-light">Contact Us</Link></li>
            </ul>
          </div>

          {/* Recent News Section */}
          <div className="w-full text-left ">
            <h3 className="font-semibold text-[10px] md:text-[32px]">RECENT NEWS</h3>
            <div className="md:space-y-3 space-y-1">
              <div className="flex  sm:flex-row items-center sm:space-x-3 space-x-2">
                <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745850308/image_dun9j2.png" alt="Tomato farming" className="md:w-32 md:h-24 w-10 h-8 rounded-md shadow-lg" />
                <div className="mt-2 sm:mt-0">
                  <p className="text-[6px] md:text-[20px] font-light">April 11, 2025</p>
                  <p className="text-[6px] md:text-[20px] font-light  leading-[1.10]">Technology and enterprise development.</p>
                  <p className="text-[6px] md:text-[20px] font-light  leading-[1.10]">Successful Tomato farming using SMART Farming techniques.</p>
                </div>
              </div>
              <div className="flex sm:flex-row items-center sm:space-x-3 space-x-2">
                <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745850308/image-1_ffcte2.png" alt="Chicken farming" className="md:w-32 md:h-24 w-10 h-8 rounded-md shadow-lg" />
                <div className="mt-2 sm:mt-0">
                  <p className="text-[6px] md:text-[20px] font-light">March 21, 2025</p>
                  <p className="text-[6px] md:text-[20px] font-light  leading-[1.10]">Technology and enterprise development.</p>
                  <p className="text-[6px] md:text-[20px] font-light leading-[1.10]">Successful chicken farming using SMART Farming techniques.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mx-auto">
          <div className="border-t md:border-[4px] border-[2px] rounded-[5px] border-white mb-5 mt-1"></div>
          <div className="flex sm:flex-row items-center justify-between ">
            {/* Social Media Icons */}
            <div className="flex flex-wrap   justify-start md:gap-5 gap-1 md:mt-1 mb-4">
              <a href="https://www.facebook.com/" className="hover:opacity-75"><img src="/facebook.png" alt="Facebook" className="md:w-14 md:h-14 h-3 w-3" /></a>
              <a href="https://www.instagram.com/" className="hover:opacity-75"><img src="/instagram.png" alt="Instagram" className="md:w-14 md:h-14 h-3 w-3" /></a>
              <a href="https://www.tiktok.com/" className="hover:opacity-75"><img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745853310/image_63_bphsd0.png" alt="TikTok" className="md:w-14 md:h-14 h-3 w-3" /></a>
              <a href="https://youtube.com/" className="hover:opacity-75"><img src="/youtube.png" alt="YouTube" className="md:w-14 md:h-14 h-3 w-3"  /></a>
              <a href="https://www.linkedin.com/in/" className="hover:opacity-75"><img src="/linkedin.png" alt="LinkedIn" className="md:w-14 md:h-14 h-3 w-3"  /></a>
              <a href="https://www.twitter.com/" className="hover:opacity-75"><img src="/twitter.png" alt="Twitter" className="md:w-14 md:h-14 h-3 w-3"  /></a>
              <a href="https://wa.me/0786025808" className="hover:opacity-75"><img src="/whatsapp.png" alt="WhatsApp" className="md:w-14 md:h-14 h-3 w-3"  /></a>
            </div>

            {/* Copyright Text */}
            <p className="md:text-[32px] text-[8px] font-semibold mb-4 text-white md:mt-2 text-left">
              <span className="text-gray-400">Copyright </span>©2025   Ad-Luck Holdings
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
